export default async (app) => {
  const dispatcher = _.clone(Backbone.Events)

  dispatcher.listenTo(app, 'reset:state', (state) => { // top-level app state has been reset
    dispatcher.listenTo(state.appStates.activities, 'change:bulkAction', (model, bulkAction) => {
      if (bulkAction === 'insert') {
        const activity = state.get('user').get('folders_enabled')
          ? state.appStates.activities.get('selected')
          : state.appStates.activities.getSelectedActivities()
        state.appStates.slideware.set({ page: 'insert', activity })
        state.set({ page: 'slideware' })
        state.appStates.activities.finishBulkAction()
      }
    })
  })
}
